import { render, staticRenderFns } from "./SocialNameDisplay.vue?vue&type=template&id=074e8f66&scoped=true&"
import script from "./SocialNameDisplay.vue?vue&type=script&lang=js&"
export * from "./SocialNameDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SocialNameDisplay.vue?vue&type=style&index=0&id=074e8f66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074e8f66",
  null
  
)

export default component.exports